import { render, staticRenderFns } from "./PVPower.vue?vue&type=template&id=6ac60c30&scoped=true&"
import script from "./PVPower.vue?vue&type=script&lang=js&"
export * from "./PVPower.vue?vue&type=script&lang=js&"
import style0 from "./PVPower.vue?vue&type=style&index=0&id=6ac60c30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac60c30",
  null
  
)

export default component.exports